import { render, staticRenderFns } from "./ForgotPasswordThanks.vue?vue&type=template&id=0d21e029&"
import script from "./ForgotPasswordThanks.vue?vue&type=script&lang=ts&"
export * from "./ForgotPasswordThanks.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports